import { register } from 'register-service-worker'

import { initLogger } from '@/lib/logger.ts'

import UpdateChecker from './update-checker.ts'

const TEN_MINUTES = 60 * 10 * 1000

const logger = initLogger(
  'Service Worker',
  {},
  {
    browser: { asObject: false },
  }
)

export function registerServiceWorker({
  url,
  baseUrl,
  onUpdateFound,
  updatePollingIntervalSeconds,
}: {
  url?: string
  baseUrl?: string
  onUpdateFound: () => void
  updatePollingIntervalSeconds?: number
}) {
  const pollingInterval = updatePollingIntervalSeconds ?? TEN_MINUTES
  const updateChecker = new UpdateChecker({ pollingInterval })

  const swUrl = url ?? `${baseUrl}/service-worker.js`

  register(swUrl, {
    ready(registration) {
      logger.info(
        `App is being served from cache by a service worker. \n For more details, visit https://goo.gl/AFskqB
				`
      )

      updateChecker.setSwRegistration(registration)
      updateChecker.setupPolling()
    },
    registered(registration) {
      logger.info('Service worker has been registered.')
      updateChecker.setSwRegistration(registration)
      updateChecker.setupPolling()
    },
    cached() {
      logger.info('Content has been cached for offline use.')
    },
    updatefound() {
      logger.info('Update found. New content is downloading.')
    },
    updated(registration) {
      logger.info('New content is available; please refresh.')
      registration?.waiting?.postMessage({ type: 'SKIP_WAITING' })

      logger.info('Ready to upgrade')
      onUpdateFound()
    },
    offline() {
      logger.info(
        'No internet connection found. App is running in offline mode.'
      )
    },
    async error(error) {
      logger.error({ error }, 'Error during service worker registration:')
    },
  })
}
